import { unwrap } from '@swarm/api-client';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export function useMeta() {
  return useQuery({
    queryKey: ['system', 'meta'],
    queryFn: async () => unwrap(await api.GET('/meta')),
    staleTime: Infinity,
  });
}
